// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__k2aKt","emails":"CreateEditClinics_emails__2RdM2","emailTagLabel":"CreateEditClinics_emailTagLabel__2I8kf"};